import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import SectionHeader from '../SectionHeader';

import './styles';

export default class BenefitsSection extends React.Component {
  render() {
    const { integrationBenefits, productBenefits, pageType } = this.props;

    const list = _.map(integrationBenefits.list, (item, index) => (
      <div key={index} className="column">
        <div className="p-b-1">
          <h4><i className="checkmark icon" />{item}</h4>
        </div>
      </div>
    ));

    return (
      <div className={classnames('IntegrationBenefit', pageType)}>
        <div className="ui container p-t-4">
          <div className="ui grid middle aligned p-b-4">
            <div className="eight wide computer-only column">
              <img src={require(`../../assets/${integrationBenefits.imageUrl}`)} />
            </div>
            <div className="eight wide computer sixteen wide mobile column">
              <h1>{integrationBenefits.titleText}</h1>
              <h4 className="no-top">{integrationBenefits.titleDescription}</h4>
              <div className="ui grid p-t-1">
                <div className="two column row">
                  {list}
                </div>
              </div>
            </div>
          </div>
          <div className="ui divider" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/IntegrationBenefitsSection/index.jsx